// @flow

import React from 'react';
import type { ScrollTrackingBlockData } from 'api/cms';
import ScrollWatcherContainer from 'containers/ScrollWatcherContainer';
import { trackEvent } from 'utils/analytics';

const { useEffect } = React;

const ScrollTrackingBlock = ({
  data: { eventName }
}: {
  data: ScrollTrackingBlockData
}) => {
  const [tracked, setTracked] = React.useState(false);
  const [scrolled, setScrolled] = React.useState(false);

  const onScroll = () => {
    if (!scrolled) {
      setScrolled(true);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  });

  return (
    <ScrollWatcherContainer>
      {({ isInViewport }) => {
        if (isInViewport && !tracked) {
          trackEvent(`Scroll: ${eventName}`, {
            reached_through: scrolled ? 'Scrolling' : 'Page Load'
          });
          setTracked(true);
        }
        return <></>;
      }}
    </ScrollWatcherContainer>
  );
};
export default ScrollTrackingBlock;
